<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>VICE CHANCELLOR</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Vice Chancellor</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02 py-5">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9 ">
                <div class="col-lg-12 order-2 order-lg-1 py-4">

                    <img src="assets/img/chancellor/4.jpg" width="" class="img-fluid" />
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-center text-md-start mb-0">
                    <span class="sub-title">Vice Chancellor Message</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary text-center text-md-start">From the Desk of Vice Chancellor</h2>
                <p class="px-2" align="justify">I am honoured and privileged to serve as Vice Chancellor at Arni University, Kangra District,
                    Himachal Pradesh. The university stand on the Principles of making Education the pathway to make
                    students confident by imparting appropriate skills and knowledge that is the need of the industry
                    and Society at large. It is envisaged that the University nurture talent who can contribute
                    responsibly to the future Society. We at Arni University focus on imparting knowledge, skills to
                    make students a person of value with high moral and ethics.</p>


            </div>

            <div class="col-lg-12 col-xl-12  ">
                <p class="px-2" align="justify">We believe and follow the philosophy of Swami Vivekananda “We want the education by which character
                    is formed, strength of mind is increased, the intellect is expanded, and by which one can stand on
                    one’s own feet”. Arni University strive to create empowered youth in multiple domains of Sciences,
                    Technologies, Life Sciences, Management, Literature, Agriculture, Health Sciences, Education, Law,
                    Pharmacy, Biolechnology and many more , who are provided hands on skilling, foundation skilling,
                    up-skilling , reskilling and building future skills acumen at all levels with multiple entry and
                    exit options.</p>

                <p class="px-2" align="justify">The Founder, Faculty and Staff are fully Dedicated to it's Credo Bringing Ambition to Life.
                    This Credo is underpinned by a value system of Ambition, Inclusivity, Intergrity,Equity
                    ,Respect and Sustainability in everything we do.</p>
                <p class="px-2" align="justify">Our students are provided the opportunity to develop entrepreneurial, scientific and societal
                    mind-set,they shall become collaborative and have global outlook through pedagogical frameworks
                    developed in class room, laboratories, field works. We at Arni University focus to provide open
                    minded research and experimental atmosphere, so that a complete personality comes out in the
                    students. Our Focus remain being a University that shall scale up employability both by way of
                    developing job seekers and job givers.</p>

                <p class="px-2" align="justify">JAI HIND ! !</p>
            </div>

        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
